"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.SeeAllBtn = exports.PlaceholderContainer = exports.Placeholder = exports.NotificationsArea = exports.Loader = exports.Header = exports.FooterIcon = exports.FooterAction = exports.Footer = exports.Container = exports.Body = exports.BellNotifications = exports.Arrow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));
var _styles = require("../Notifications/styles");
var _constants = require("../../constants");
const PlaceholderContainer = exports.PlaceholderContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__PlaceholderContainer",
  componentId: "sc-10eib3-0"
})(["display:flex;height:100%;flex-direction:column;padding:24px;max-width:368px;"]);
const Placeholder = exports.Placeholder = _styledComponents.default.p.withConfig({
  displayName: "styles__Placeholder",
  componentId: "sc-10eib3-1"
})(["color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";display:block;text-align:center;margin:auto;"], ({
  theme
}) => theme.colors.appFrame.bellWidget.placeholderColor, ({
  theme
}) => theme.AppFrame.bellWidget.placeholder.fontFamily, ({
  theme
}) => theme.AppFrame.bellWidget.placeholder.fontSize, ({
  theme
}) => theme.AppFrame.bellWidget.placeholder.fontWeight, ({
  theme
}) => theme.AppFrame.bellWidget.placeholder.lineHeight);
const Loader = exports.Loader = _styledComponents.default.div.withConfig({
  displayName: "styles__Loader",
  componentId: "sc-10eib3-2"
})(["font-size:14px;font-weight:300;text-align:center;color:", ";position:relative;padding:20px 0;"], ({
  theme
}) => theme.colors.appFrame.bellWidget.loaderColor);
const BellNotifications = exports.BellNotifications = _styledComponents.default.div.withConfig({
  displayName: "styles__BellNotifications",
  componentId: "sc-10eib3-3"
})(["z-index:100;transition:opacity 0.3s ease-in-out;", ""], ({
  theme
}) => theme.name === _constants.THEMES.mds && `
    ${_styles.SnackElement} {
      border: none;
    }
  `);
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-10eib3-4"
})(["position:relative;box-shadow:", ";"], ({
  theme
}) => theme.AppFrame.bellWidget.boxShadow);
const Header = exports.Header = _styledComponents.default.div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-10eib3-5"
})(["background-color:", ";border-bottom:1px solid ", ";height:", ";padding:", ";border-radius:2px 2px 0 0;position:relative;"], ({
  theme
}) => theme.colors.appFrame.bellWidget.headerBg, ({
  theme
}) => theme.colors.appFrame.bellWidget.headerBorderColor, ({
  theme
}) => theme.AppFrame.bellWidget.header.height, ({
  theme
}) => theme.AppFrame.bellWidget.header.padding);
const Title = exports.Title = _styledComponents.default.span.withConfig({
  displayName: "styles__Title",
  componentId: "sc-10eib3-6"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";text-align:", ";text-transform:", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:block;"], ({
  theme
}) => theme.AppFrame.bellWidget.header.fontFamily, ({
  theme
}) => theme.AppFrame.bellWidget.header.fontSize, ({
  theme
}) => theme.AppFrame.bellWidget.header.fontWeight, ({
  theme
}) => theme.AppFrame.bellWidget.header.lineHeight, ({
  theme
}) => theme.colors.appFrame.bellWidget.headerTextColor, ({
  theme
}) => theme.AppFrame.bellWidget.header.textAlign, ({
  theme
}) => theme.AppFrame.bellWidget.header.textTransform);
const Body = exports.Body = _styledComponents.default.div.withConfig({
  displayName: "styles__Body",
  componentId: "sc-10eib3-7"
})(["border-radius:0 0 3px 3px;display:flex;flex-direction:column;background-color:", ";width:", ";"], ({
  theme
}) => theme.colors.appFrame.bellWidget.contentBg, ({
  theme
}) => theme.AppFrame.bellWidget.width);
const NotificationsArea = exports.NotificationsArea = _styledComponents.default.div.withConfig({
  displayName: "styles__NotificationsArea",
  componentId: "sc-10eib3-8"
})(["overflow-y:auto;height:350px;", "{box-shadow:none;}", "{border-bottom:1px solid ", ";padding:0;&:hover{", "{background-color:", ";}}}"], _styles.SnackElement, _styles.SnackWrapper, ({
  theme
}) => theme.colors.appFrame.bellWidget.itemBorder, _styles.SnackElement, ({
  theme
}) => theme.colors.appFrame.bellWidget.itemHoverBg);
const Footer = exports.Footer = _styledComponents.default.div.withConfig({
  displayName: "styles__Footer",
  componentId: "sc-10eib3-9"
})(["height:", ";display:flex;flex-direction:column;justify-content:center;border-top:1px solid ", ";padding-right:", ";"], ({
  theme
}) => theme.AppFrame.bellWidget.footer.height, ({
  theme
}) => theme.colors.appFrame.bellWidget.headerBorderColor, ({
  theme
}) => theme.spacing.s3);
const FooterAction = exports.FooterAction = _styledComponents.default.div.withConfig({
  displayName: "styles__FooterAction",
  componentId: "sc-10eib3-10"
})(["position:relative;display:flex;justify-content:center;"]);
const FooterIcon = exports.FooterIcon = (0, _styledComponents.default)(_ArrowRight.default).withConfig({
  displayName: "styles__FooterIcon",
  componentId: "sc-10eib3-11"
})(["align-self:center;cursor:pointer;fill:", ";margin-left:", ";"], ({
  theme
}) => theme.colors.appFrame.bellWidget.footerTextColor, ({
  theme
}) => theme.spacing.s2);
const SeeAllBtn = exports.SeeAllBtn = _styledComponents.default.span.withConfig({
  displayName: "styles__SeeAllBtn",
  componentId: "sc-10eib3-12"
})(["color:", ";cursor:pointer;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], ({
  theme
}) => theme.colors.appFrame.bellWidget.footerTextColor, ({
  theme
}) => theme.AppFrame.bellWidget.footer.fontFamily, ({
  theme
}) => theme.AppFrame.bellWidget.footer.fontSize, ({
  theme
}) => theme.AppFrame.bellWidget.footer.fontWeight, ({
  theme
}) => theme.AppFrame.bellWidget.footer.lineHeight);
const Arrow = exports.Arrow = _styledComponents.default.div.withConfig({
  displayName: "styles__Arrow",
  componentId: "sc-10eib3-13"
})(["position:absolute;width:10px;height:10px;&[data-placement*='bottom']{top:0;left:0;margin-top:-5px;width:14px;height:10px;&::before{border-width:0 5px 5px 5px;border-color:transparent transparent ", " transparent;}}&::before{content:'';margin:auto;display:block;width:0;height:0;border-style:solid;}"], ({
  theme
}) => theme.colors.appFrame.bellWidget.headerBg);